// extracted by mini-css-extract-plugin
module.exports = {"button":"styles-module--button--2YX_l","active":"styles-module--active--2SZt5"};